// Метки референсов — @reference_N и @voice_N (ShotReferenceInput#reference_label).
// Номер идёт хвостом, поэтому наивный includes() считает @reference_1 найденным
// внутри @reference_10: до десятого референса предупреждение при удалении врёт
// в обе стороны — пугает зря и молчит там, где ссылка действительно есть.

const REGEXP_SPECIALS = /[.*+?^${}()|[\]\\]/g

/** Стоит ли ссылка на этот референс в тексте промпта. */
export function promptMentionsReference(promptText: string, label: string): boolean {
  if (!label) return false
  const escaped = label.replace(REGEXP_SPECIALS, "\\$&")
  // Цифра следом — значит это метка с бо́льшим номером, а не наша.
  return new RegExp(`${escaped}(?!\\d)`).test(promptText)
}
